import { t } from 'i18next';
import moment from 'moment';
import {
  DATE_FORMAT,
  DIRECTION_TYPE,
  PROJECT_CHILD_ITEM_RESIDENCE_TYPE
} from '../commons/constants';
import { ProjectChildItemTypes } from '../types';
import { TermOfContractType } from '../types/termOfContract';
import { renderChildItemType, renderDirectionType } from './columnRenderUtils';
import { getItemSquare } from './functionUtils';

export const formatNumberToSquareString = (val: number): string => {
  if (!val || Number.isNaN(val)) return null;

  const decimal = (val || 0)
    .toFixed(2)
    .replace('.', ',')
    .replace(/\B(?=(\d{3})+(?!\d))/g, '')
    .replace(',00', '');

  return `${decimal} m²`;
};

export const formatDateTime = (value: Date): string => {
  return moment(value).format('DD/MM/YYYY, h:mm:ss a');
};

export const formatDate = (value: Date | string): string => {
  return moment(value).format(DATE_FORMAT);
};

export const getSubtitleProjectChildItem = (item: ProjectChildItemTypes): string => {
  const subTitlePaths = [];
  if (!!item.residenceType && PROJECT_CHILD_ITEM_RESIDENCE_TYPE[item.residenceType]) {
    subTitlePaths.push(renderChildItemType(item.residenceType));
  }

  if (!!item.direction && DIRECTION_TYPE[item.direction]) {
    subTitlePaths.push(renderDirectionType(item.direction));
  }

  if (item?.bedrooms) {
    subTitlePaths.push(`${item.bedrooms} ${t('common.short-bedroom.title')}`);
  }

  if (item?.bathrooms) {
    subTitlePaths.push(`${item.bathrooms} ${t('common.short-bathroom.title')}`);
  }

  if (!!item.square || !!item.usableSquare) {
    subTitlePaths.push(getItemSquare({ square: item.square, usableSquare: item.usableSquare }));
  }
  return subTitlePaths.join(' • ');
};

export const getOptions = (data: TermOfContractType[]): { label: string; value: string }[] => {
  return data.map((i) => {
    return {
      label: i.name,
      value: i.code,
    };
  });
};
